export default __webpack_public_path__ + "static/media/sms-solid.ad56aece.svg";